"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.filter('dateOfMonth', function () {
  return function (number) {
    switch (number) {
      case 1:
        return "1er";
      default:
        return number;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/filters/dateOfMonth.js
// module id = 2700
// module chunks = 13